import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnInputFormField } from './components/input-form-field/input.form-field';
import { SnPasswordControl } from './components/password-control/password.control';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'input',
          component: SnInputFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    // Libs
    SnIconModule,
    SnButtonModule,
    TranslationModule,
  ],
  exports: [MatInputModule, SnPasswordControl],
  declarations: [SnInputFormField, SnPasswordControl],
})
export class SnFormInputModule {}
